import { Routes } from '@angular/router';
import { LayoutComponent } from './pages/layout/layout.component';

export const routes: Routes = [
    {
        path: '',
        component: LayoutComponent,
        children: [
            {
                path: '',
                loadComponent: () =>
                    import('./pages/home/page/page.component').then(m => m.PageComponent),
                data: {
                    title: 'Home',
                    description:
                        'State Street private capital indices provide deep coverage of global private markets, delivering accurate, unbiased, timely benchmarks and customizable analytics built on verified cash flow and valuation data from the book-of-records at State Street.'
                }
            },
            {
                path: 'solutions',
                loadComponent: () =>
                    import('./pages/solutions/page/page.component').then(
                        m => m.SolutionsPageComponent
                    ),
                data: {
                    title: 'Solutions',
                    description:
                        'State Street private capital indices provide deep coverage of global private markets, delivering accurate, unbiased, timely benchmarks and customizable analytics built on verified cash flow and valuation data from the book-of-records at State Street.'
                }
            },
            {
                path: 'news',
                loadComponent: () =>
                    import('./pages/news/page/page.component').then(m => m.NewsPageComponent),
                data: {
                    title: 'News',
                    description:
                        'Learn more about the latest news, products releases and market trends with State Street private capital indices.'
                },
                children: [
                    {
                        path: ':id',
                        loadComponent: () =>
                            import('./pages/news/id/page/page.component').then(
                                m => m.NewsDetailPageComponent
                            )
                    }
                ]
            },
            {
                path: 'publications',
                loadComponent: () =>
                    import('./pages/publications/page/page.component').then(
                        m => m.PublicationsPageComponent
                    ),
                data: {
                    title: 'Publications',
                    description:
                        'Explore quarterly private market performance trends, industry insights, and research publications with State Street private capital indices data.'
                },
                children: [
                    {
                        path: ':id',
                        loadComponent: () =>
                            import('./pages/publications/id/page/page.component').then(
                                m => m.PublicationDetailPageComponent
                            )
                    }
                ]
            },
            {
                path: 'login',
                loadComponent: () =>
                    import('./pages/login/page/page.component').then(m => m.LoginPageComponent),
                data: {
                    title: 'Login',
                    description: 'Sign in to access Private Capital Indices content.'
                }
            },
            {
                path: 'not-found',
                loadComponent: () =>
                    import('./pages/not-found/page/page.component').then(
                        m => m.NotFoundPageComponent
                    ),
                data: {
                    title: 'Page Not Found',
                    description:
                        "The page you requested couldn't be found. It may have been moved or deleted."
                }
            }
        ]
    },
    {
        path: '**',
        redirectTo: '/not-found'
    }
];
